module.exports = __webpack_public_path__ + "img/hotdog-top-001sp.066511cf.jpg";